/**
 * Created by Josef Jurca on 6.3.2017.
 */

import {
    convertForGetAsset,
    convertFromRead
} from '../adapters/assets';

import {isValidResponse} from '../validators/assets';

import Asset from 'models/asset';

/**
 * Returns asset with ID.
 *
 * @param {number} id - Asset id.
 * @param {string} query - Asset query.
 * @returns {Promise} Get asset promise.
 */
export function getAsset (id, query) {
    const url = this._baseUrl + this._endPoints.asset;

    return this.read(
        {
            url: url,
            data: convertForGetAsset.call(this, id, query)
        })
        .then(response => {
            if (!isValidResponse(response)) {
                return Promise.reject(response);
            }
            
            return new Asset(convertFromRead.call(this, response.result));
        });
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/assets.js